import { fillAdminCourseDetails } from "../../Pages/AdminCourseManagement/Fills";
import { ajaxRequest } from "../Ajax/ajax";
import { hideModal, successToast } from "../utils";

export function inviteTutorToCourse(email, courseId, btn=false){

    const url = '/course/' + courseId.toString() + '/tutor/invite'

    const data = {
        email: email
    }

    const success = function(data){
        fillAdminCourseDetails(courseId); // Hier könnte man noch offenstehende Freischaltungen vermerken
          successToast('Nutzer/-in mit der Mail: ' + email + ' wurde erfolgreich der Job als Tutor/-in angeboten', 'Erfolg', 7500, true);
          hideModal('activate-tutor');
    }

    ajaxRequest(url, success, data, btn);

  }